import { debugInit } from './debugInit';
import { devToolsInit } from './devToolsInit';
import { sentryInit } from './sentryInit';

export const init = () => {
  devToolsInit();
  debugInit();
  sentryInit();
};
